import React from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import Text from '@components/Text';

const RadioContainer = styled.button<StyledProps>`
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  position: relative;
  margin: 0;
  z-index: 2;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    background-color: ${props => !props.isSelected ? props.theme?.colors.grey[600] : 'transparent'};
    transition: background-color .35s;
  }
  &:nth-child(odd) {
    &:after{
      content: "";
      display: block;
      height: 30px;
      width: 1px;
      background-color: ${props => props.theme?.colors.grey[100]};
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      opacity: 0.8;
      visibility: ${props => !props.isSelected && props.trackedByGroup ? 'visible' : 'hidden'};
    }
  }
  & p {
    font-size: 20px;
    position: relative;
    z-index: 3;
    transition: color .35s;
  }
`
interface StyledProps {
  theme?: ITheme;
  isSelected: boolean;
  width?: number;
  trackedByGroup: boolean;
}

export interface RadioButtonProps {
  className?: string | undefined;
  text: string;
  onChange: (value: string | number | undefined) => void;
  selected: string | number | null;
  value: string | number | boolean | undefined;
  theme?: ITheme;
  width?: number;
  trackedByGroup: boolean;
  name?: string;
}

function RadioButton({ text, onChange, selected, value, className, trackedByGroup, name }: RadioButtonProps) {
  const theme = useTheme();
  const isSelected = selected === value;
  const color = isSelected ? theme.colors.white : theme.colors.grey[300];
  return (
    <RadioContainer
      name={name}
      className={className}
      onClick={(e: any) => onChange({ ...e, target: { ...e.target, value, name } })}
      theme={theme}
      isSelected={isSelected}
      trackedByGroup={trackedByGroup}
    >
      <Text color={color} fontWeight={isSelected ? 'bold' : 'normal'} align="center">{text}</Text>
    </RadioContainer>
  );
};

RadioButton.defaultProps = {
  text: '',
  selected: null,
  vaue: undefined,
  onChange: () => { },
  trackedByGroup: false
}

export default RadioButton;
